import styled, { css } from "styled-components"
import { Fade } from "react-awesome-reveal"

const height = css`
  height: 100vh;
  min-height: 650px;
`

export const StickyDiv = styled.div`
  overflow: hidden;
  background-color: white;
`

export const Animation = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

export const CustomFade = styled(Fade)`
  ${height};
  position: relative;
  z-index: 2;
`

export const Sticky = styled.div`
  height: 100vh;
  width: 100%;
  background-color: white;
`
